import {h} from 'preact';
import {Mutation} from 'react-apollo';
import {client} from '@core/GraphQLProvider';

export const makeMutation = ( {mutation, ...props} ) => ( {render} ) =>
    <Mutation client={client} mutation={mutation} {...props}>
        {/*fold the mutation and result into a single argument*/}
        {( x, y ) => render( {mutation: x, result: y} )}
    </Mutation>;